import { render, staticRenderFns } from "./onIpfcTmp.vue?vue&type=template&id=5e114342"
import script from "./onIpfcTmp.vue?vue&type=script&lang=js"
export * from "./onIpfcTmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports